import { Box, Typography } from "@mui/material";
import useStyles from "../Chatbot.styles";
import { useIntl } from "react-intl";

import light_eddy_animation from "assets/images/pngs/light_eddy_animation.png";
import lighthouse_eddy_animation from "assets/images/pngs/lighthouse_eddy_animation.png";

const ChatbotLoading = ({ isFirstLoad }: { isFirstLoad: boolean }) => {
    const classes = useStyles();
    const intl = useIntl();

    const LightHouseAnimation = ({ size }: { size: number }) => (
        <Box className={classes.lightHouseAnimation} sx={{ width: size }}>
            <img src={light_eddy_animation} alt="" />
            <img src={lighthouse_eddy_animation} alt="" />
        </Box>
    );

    return isFirstLoad ? (
        <Box
            className={classes.initialLoadingWrapper}
            role="status"
            aria-live="polite"
            aria-label={intl.formatMessage({ id: "chatbot.initial.loading.message" })}
        >
            <Box display="flex" alignItems="center" justifyContent="flex-start" mb={1.5}>
                <Box className={classes.loadingIndicator} />
                <Typography className={classes.loadingLegend}>
                    {intl.formatMessage({ id: "chatbot.initial.loading.message" })}
                </Typography>
            </Box>
            <LightHouseAnimation size={132} />
        </Box>
    ) : (
        <Box
            sx={{ display: "flex" }}
            role="status"
            aria-live="polite"
            aria-label={intl.formatMessage({ id: "chatbot.loading.message" })}
        >
            <LightHouseAnimation size={66} />
            <Box className={classes.messageLoadingText}>
                <Box className={classes.loadingIndicator} />
                <Typography className={classes.loadingLegend}>
                    {intl.formatMessage({ id: "chatbot.loading.message" })}
                </Typography>
            </Box>
        </Box>
    );
};

export default ChatbotLoading;
